<div class="w-full h-full pb-40"> 
    <app-tab-header [tabs]="tabs"></app-tab-header>

    <div class="flex flex-row gap-10 flex-wrap">
        
        <div class="w-700-px mx-auto mt-20 border-gray-400 b-orange">
            <header class="p-2 b-orange-bottom font-bold orange-text">
                <h2>ACTIVE RATES</h2>
            </header>
            
            <div class="grid grid-cols-12 gap-4 items-center p-4">
                <!-- BUYLOAD ACTIVE -->
                <div class="col-span-6">
                    <div class="flex flex-row gap-1 items-center">
                        <span class="text-xs w-100-px font-semibold">Buyload:</span>
                        <div [appHighlightOnActive]="isEditingBuyload" class="card-input flex items-center space-x-3 w-full">
                            <input *ngIf="isLoading" disabled class="bg-gray-100 italic text-gray-500 cursor-wait focus:outline-none w-full h-30-px rounded-md pl-3" type="text" value="Loading...">
                            <input 
                                *ngIf="!isLoading" 
                                [(ngModel)]="redeemPercentageBuyload" 
                                [readonly]="!isEditingBuyload" 
                                [class.cursor-not-allowed]="!isEditingBuyload" 
                                [class.bg-gray-100]="isEditingBuyload" 
                                [class.bg-white]="isEditingBuyload" 
                                class="input-no-spinner focus:outline-none w-full h-30-px rounded-md pl-3 placeholder-gray-500 italic" 
                                type="number" step="0.01" placeholder="Enter percentage"
                                appOnlyNumber [allowDecimal]="true"
                            >
                        </div>
                    </div>
                </div>
                <div class="col-span-6 flex gap-2 justify-start">
                    <ng-container *ngIf="!isLoading">
                        <button (click)="toggleEdit('buyload')" class="uppercase custom-btn action-btn-blue2 font-semibold px-12 py-3">
                            {{ isEditingBuyload ? 'Cancel' : 'Edit' }}
                        </button>
                        <button (click)="update_redeem_percentage('buyload')" 
                                [disabled]="!isEditingBuyload" 
                                [class.opacity-50]="!isEditingBuyload" 
                                [class.cursor-not-allowed]="!isEditingBuyload" 
                                class="uppercase power-btn2 active custom-btn font-semibold px-12 py-3">
                            save
                        </button>
                    </ng-container>
                </div>

                <!-- PINS ACTIVE -->
                <div class="col-span-6">
                    <div class="flex flex-row gap-1 items-center">
                        <span class="text-xs w-100-px font-semibold">Pins:</span>
                        <div [appHighlightOnActive]="isEditingPins" class="card-input flex items-center space-x-3 w-full">
                            <input *ngIf="isLoading" disabled class="bg-gray-100 italic text-gray-500 cursor-wait focus:outline-none w-full h-30-px rounded-md pl-3" type="text" value="Loading...">
                            <input 
                                *ngIf="!isLoading" 
                                [(ngModel)]="redeemPercentagePins" 
                                [readonly]="!isEditingPins" 
                                [class.cursor-not-allowed]="!isEditingPins" 
                                [class.bg-gray-100]="isEditingPins" 
                                [class.bg-white]="isEditingPins" 
                                class="input-no-spinner focus:outline-none w-full h-30-px rounded-md pl-3 placeholder-gray-500 italic" 
                                type="number" step="0.01" placeholder="Enter percentage"
                            >
                        </div>
                    </div>
                </div>
                <div class="col-span-6 flex gap-2 justify-start">
                    <ng-container *ngIf="!isLoading">
                        <button (click)="toggleEdit('pins')" class="uppercase custom-btn action-btn-blue2 font-semibold px-12 py-3">
                            {{ isEditingPins ? 'Cancel' : 'Edit' }}
                        </button>
                        <button (click)="update_redeem_percentage('pins')" 
                                [disabled]="!isEditingPins" 
                                [class.opacity-50]="!isEditingPins" 
                                [class.cursor-not-allowed]="!isEditingPins" 
                                class="uppercase power-btn2 active custom-btn font-semibold px-12 py-3">
                            save
                        </button>
                    </ng-container>
                </div>

                <!-- STORES ACTIVE -->
                <div class="col-span-6">
                    <div class="flex flex-row gap-1 items-center">
                        <span class="text-xs w-100-px font-semibold">Stores:</span>
                        <div [appHighlightOnActive]="isEditingStores" class="card-input flex items-center space-x-3 w-full">
                            <input *ngIf="isLoading" disabled class="bg-gray-100 italic text-gray-500 cursor-wait focus:outline-none w-full h-30-px rounded-md pl-3" type="text" value="Loading...">
                            <input 
                                *ngIf="!isLoading" 
                                [(ngModel)]="redeemPercentageStores" 
                                [readonly]="!isEditingStores" 
                                [class.cursor-not-allowed]="!isEditingStores" 
                                [class.bg-gray-100]="isEditingStores" 
                                [class.bg-white]="isEditingStores" 
                                class="input-no-spinner focus:outline-none w-full h-30-px rounded-md pl-3 placeholder-gray-500 italic" 
                                type="number" step="0.01" placeholder="Enter percentage"
                                appOnlyNumber [allowDecimal]="true"
                            >
                        </div>
                    </div>
                </div>
                <div class="col-span-6 flex gap-2 justify-start">
                    <ng-container *ngIf="!isLoading">
                        <button (click)="toggleEdit('stores')" class="uppercase custom-btn action-btn-blue2 font-semibold px-12 py-3">
                            {{ isEditingStores ? 'Cancel' : 'Edit' }}
                        </button>
                        <button (click)="update_redeem_percentage('stores')" 
                                [disabled]="!isEditingStores" 
                                [class.opacity-50]="!isEditingStores" 
                                [class.cursor-not-allowed]="!isEditingStores" 
                                class="uppercase power-btn2 active custom-btn font-semibold px-12 py-3">
                            save
                        </button>
                    </ng-container>
                </div>

                <!-- PAYBILLS ACTIVE -->
                <div class="col-span-6">
                    <div class="flex flex-row gap-1 items-center">
                        <span class="text-xs w-100-px font-semibold">Paybills:</span>
                        <div [appHighlightOnActive]="isEditingPaybills" class="card-input flex items-center space-x-3 w-full">
                            <input *ngIf="isLoading" disabled class="bg-gray-100 italic text-gray-500 cursor-wait focus:outline-none w-full h-30-px rounded-md pl-3" type="text" value="Loading...">
                            <input 
                                *ngIf="!isLoading" 
                                [(ngModel)]="redeemPercentagePaybills" 
                                [readonly]="!isEditingPaybills" 
                                [class.cursor-not-allowed]="!isEditingPaybills" 
                                [class.bg-gray-100]="isEditingPaybills" 
                                [class.bg-white]="isEditingPaybills" 
                                class="input-no-spinner focus:outline-none w-full h-30-px rounded-md pl-3 placeholder-gray-500 italic" 
                                type="number" step="0.01" placeholder="Enter percentage"  
                                appOnlyNumber [allowDecimal]="true"
                            >
                        </div>
                    </div>
                </div>
                <div class="col-span-6 flex gap-2 justify-start">
                    <ng-container *ngIf="!isLoading">
                        <button (click)="toggleEdit('paybills')" class="uppercase custom-btn action-btn-blue2 font-semibold px-12 py-3">
                            {{ isEditingPaybills ? 'Cancel' : 'Edit' }}
                        </button>
                        <button (click)="update_redeem_percentage('paybills')" 
                                [disabled]="!isEditingPaybills" 
                                [class.opacity-50]="!isEditingPaybills" 
                                [class.cursor-not-allowed]="!isEditingPaybills" 
                                class="uppercase power-btn2 active custom-btn font-semibold px-12 py-3">
                            save
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>

        <!-- PRE-SET RATES SECTION -->
        <div class="w-700-px mx-auto mt-20 border-gray-400 b-orange">
            <header class="p-2 b-orange-bottom font-bold orange-text">
                <h2>PRE - SET RATES</h2>
            </header>
            
            <div class="flex flex-col p-4 gap-4">
                <!-- BUYLOAD PRESET -->
                <div class="flex flex-row items-center gap-4">
                    <div class="flex gap-2" style="min-width: 110px;">
                        <button *ngIf="!preSetRates['buyload'].isSet" (click)="handlePreSetClick('buyload')" class="uppercase custom-btn action-btn-blue2 font-semibold px-12 py-3">Set</button>
                        <ng-container *ngIf="preSetRates['buyload'].isSet">
                            <button (click)="clearPreSet('buyload')" class="uppercase custom-btn font-semibold btn-dark-orange px-12 py-3" style="width: 43px; height: 23px; font-size: 10px;">Clear</button>
                        </ng-container>
                    </div>
    
                    <div class="relative" style="width: 400px;">
                        <div class="card-input flex items-center space-x-3" style="height: 40px;">
                            <div class="flex flex-row justify-between items-center gap-3">
                                <ng-container *ngIf="preSetRates['buyload'].isSet; else showNABuyload">
                                    <span class="text-xs font-semibold">Effective Date:</span>
                                    <span class="text-xs w-120-px font-semibold">| {{ getDisplayDate(preSetRates['buyload'].date) }}</span>
                                    <span class="text-xs font-semibold">| {{ preSetRates['buyload'].rate | number:'1.2-2'  }}%</span>
                                </ng-container>
                                <ng-template #showNABuyload><span class="text-xs font-semibold text-gray-400">N/A</span></ng-template>
                            </div>
                        </div>
    
                        <!-- POPUP FOR BUYLOAD -->
                        <div *ngIf="activeCategory === 'buyload'" 
                            @popupAnimation
                            [formGroup]="presetForm"
                            class="absolute left-0 top-full mt-2 b-orange flex flex-col gap-2 p-4 rounded-md bg-white shadow-xl z-50 origin-top" 
                            style="width: 100%; min-width: 300px;"
                        >
                            <div class="flex flex-row gap-2 items-center">
                                <span class="text-xs font-semibold w-20">Set Rate:</span>
                                <div class="card-input flex items-center space-x-3 flex-1">
                                    <input formControlName="rate" class="input-no-spinner bg-gray-100 text-xs italic text-black placeholder-gray-500 focus:outline-none w-full h-30-px rounded-md pl-2 border border-gray-300" type="number" placeholder="Enter Rate" appOnlyNumber [allowDecimal]="true">
                                </div>
                            </div>
                            
                            <!-- USING REUSABLE COMPONENT HERE -->
                            <div class="flex flex-row gap-2 items-center">
                                <span class="text-xs font-semibold w-20">Set Date:</span>
                                <div class="card-input flex items-center space-x-3 flex-1">
                                    <app-date-input 
                                        class="w-full"
                                        [parentForm]="presetForm" 
                                        controlName="date" 
                                        [min]="minDate">
                                    </app-date-input>
                                </div>
                            </div>

                            <div class="flex flex-row gap-2 items-center justify-center mt-2">
                                <button (click)="closePopup()" class="uppercase custom-btn power-btn2 font-semibold px-8 py-2 text-xs">Cancel</button>
                                <button (click)="savePreSet()" class="uppercase power-btn2 active custom-btn font-semibold px-8 py-2 text-xs">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
    
                <!-- PINS PRESET -->
                <div class="flex flex-row items-center gap-4">
                    <div class="flex gap-2" style="min-width: 110px;">
                        <button *ngIf="!preSetRates['pins'].isSet" (click)="handlePreSetClick('pins')" class="uppercase custom-btn font-semibold px-12 py-3 action-btn-blue2">Set</button>
                        <ng-container *ngIf="preSetRates['pins'].isSet">
                            <button (click)="clearPreSet('pins')" class="uppercase custom-btn font-semibold btn-dark-orange px-12 py-3" style="width: 43px; height: 23px; font-size: 10px;">Clear</button>
                        </ng-container>
                    </div>
    
                    <div class="relative" style="width: 400px;">
                        <div class="card-input flex items-center space-x-3" style="height: 40px;">
                            <div class="flex flex-row justify-between items-center gap-3">
                                <ng-container *ngIf="preSetRates['pins'].isSet; else showNAPins">
                                    <span class="text-xs font-semibold">Effective Date:</span>
                                    <span class="text-xs w-120-px font-semibold">| {{ getDisplayDate(preSetRates['pins'].date) }}</span>
                                    <span class="text-xs font-semibold">| {{ preSetRates['pins'].rate | number:'1.2-2' }}%</span>
                                </ng-container>
                                <ng-template #showNAPins><span class="text-xs font-semibold text-gray-400">N/A</span></ng-template>
                            </div>
                        </div>
    
                        <!-- POPUP FOR PINS -->
                        <div *ngIf="activeCategory === 'pins'" 
                            @popupAnimation
                            [formGroup]="presetForm"
                            class="absolute left-0 top-full mt-2 b-orange flex flex-col gap-2 p-4 rounded-md bg-white shadow-xl z-50 origin-top" 
                            style="width: 100%; min-width: 300px;">
                            <div class="flex flex-row gap-2 items-center">
                                <span class="text-xs font-semibold w-20">Set Rate:</span>
                                <div class="card-input flex items-center space-x-3 flex-1">
                                    <input formControlName="rate" class="input-no-spinner bg-gray-100 italic text-xs text-black placeholder-gray-500 focus:outline-none w-full h-30-px rounded-md pl-2 border border-gray-300" type="number" placeholder="Enter Rate" appOnlyNumber [allowDecimal]="true">
                                </div>
                            </div>

                            <!-- USING REUSABLE COMPONENT HERE -->
                            <div class="flex flex-row gap-2 items-center">
                                <span class="text-xs font-semibold w-20">Set Date:</span>
                                <div class="card-input flex items-center space-x-3 flex-1">
                                    <app-date-input 
                                        class="w-full"
                                        [parentForm]="presetForm" 
                                        controlName="date" 
                                        [min]="minDate">
                                    </app-date-input>
                                </div>
                            </div>

                            <div class="flex flex-row gap-2 items-center justify-center mt-2">
                                <button (click)="closePopup()" class="uppercase custom-btn power-btn2 font-semibold px-8 py-2 text-xs">Cancel</button>
                                <button (click)="savePreSet()" class="uppercase power-btn2 active custom-btn font-semibold px-8 py-2 text-xs">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
    
                <!-- STORES PRESET -->
                <div class="flex flex-row items-center gap-4">
                    <div class="flex gap-2" style="min-width: 110px;">
                        <button *ngIf="!preSetRates['stores'].isSet" (click)="handlePreSetClick('stores')" class="uppercase custom-btn font-semibold px-12 py-3 action-btn-blue2">Set</button>
                        <ng-container *ngIf="preSetRates['stores'].isSet">
                            <button (click)="clearPreSet('stores')" class="uppercase custom-btn font-semibold btn-dark-orange px-12 py-3" style="width: 43px; height: 23px; font-size: 10px;">Clear</button>
                        </ng-container>
                    </div>
    
                    <div class="relative" style="width: 400px;">
                        <div class="card-input flex items-center space-x-3" style="height: 40px;">
                            <div class="flex flex-row justify-between items-center gap-3">
                                <ng-container *ngIf="preSetRates['stores'].isSet; else showNAStores">
                                    <span class="text-xs font-semibold">Effective Date:</span>
                                    <span class="text-xs w-120-px font-semibold">| {{ getDisplayDate(preSetRates['stores'].date) }}</span>
                                    <span class="text-xs font-semibold">| {{ preSetRates['stores'].rate | number:'1.2-2' }}%</span>
                                </ng-container>
                                <ng-template #showNAStores><span class="text-xs font-semibold text-gray-400">N/A</span></ng-template>
                            </div>
                        </div>
    
                        <!-- POPUP FOR STORES -->
                        <div *ngIf="activeCategory === 'stores'" 
                            @popupAnimation
                            [formGroup]="presetForm"
                            class="absolute left-0 top-full mt-2 b-orange flex flex-col gap-2 p-4 rounded-md bg-white shadow-xl z-50 origin-top" 
                            style="width: 100%; min-width: 300px;">
                            <div class="flex flex-row gap-2 items-center">
                                <span class="text-xs font-semibold w-20">Set Rate:</span>
                                <div class="card-input flex items-center space-x-3 flex-1">
                                    <input formControlName="rate" class="input-no-spinner bg-gray-100 italic text-xs text-black placeholder-gray-500 focus:outline-none w-full h-30-px rounded-md pl-2 border border-gray-300" type="number" placeholder="Enter Rate" appOnlyNumber [allowDecimal]="true">
                                </div>
                            </div>
                            
                            <!-- USING REUSABLE COMPONENT HERE -->
                            <div class="flex flex-row gap-2 items-center">
                                <span class="text-xs font-semibold w-20">Set Date:</span>
                                <div class="card-input flex items-center space-x-3 flex-1">
                                    <app-date-input 
                                        class="w-full"
                                        [parentForm]="presetForm" 
                                        controlName="date" 
                                        [min]="minDate">
                                    </app-date-input>
                                </div>
                            </div>

                            <div class="flex flex-row gap-2 items-center justify-center mt-2">
                                <button (click)="closePopup()" class="uppercase custom-btn power-btn2 font-semibold px-8 py-2 text-xs">Cancel</button>
                                <button (click)="savePreSet()" class="uppercase power-btn2 active custom-btn font-semibold px-8 py-2 text-xs">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
    
                <!-- PAYBILLS PRESET -->
                <div class="flex flex-row items-center gap-4">
                    <div class="flex gap-2" style="min-width: 110px;">
                        <button *ngIf="!preSetRates['paybills'].isSet" (click)="handlePreSetClick('paybills')" class="uppercase custom-btn font-semibold px-12 py-3 action-btn-blue2">Set</button>
                        <ng-container *ngIf="preSetRates['paybills'].isSet">
                            <button (click)="clearPreSet('paybills')" class="uppercase custom-btn font-semibold btn-dark-orange px-12 py-3" style="width: 43px; height: 23px; font-size: 10px;">Clear</button>
                        </ng-container>
                    </div>
    
                    <div class="relative" style="width: 400px;">
                        <div class="card-input flex items-center space-x-3" style="height: 40px;">
                            <div class="flex flex-row justify-between items-center gap-3">
                                <ng-container *ngIf="preSetRates['paybills'].isSet; else showNAPaybills">
                                    <span class="text-xs font-semibold">Effective Date:</span>
                                    <span class="text-xs w-120-px font-semibold">| {{ getDisplayDate(preSetRates['paybills'].date) }}</span>
                                    <span class="text-xs font-semibold">| {{ preSetRates['paybills'].rate | number:'1.2-2' }}%</span>
                                </ng-container>
                                <ng-template #showNAPaybills><span class="text-xs font-semibold text-gray-400">N/A</span></ng-template>
                            </div>
                        </div>
    
                        <!-- POPUP FOR PAYBILLS -->
                        <div *ngIf="activeCategory === 'paybills'" 
                            @popupAnimation
                            [formGroup]="presetForm"
                            class="absolute left-0 top-full mt-2 b-orange flex flex-col gap-2 p-4 rounded-md bg-white shadow-xl z-50 origin-top" 
                            style="width: 100%; min-width: 300px;">
                            <div class="flex flex-row gap-2 items-center">
                                <span class="text-xs font-semibold w-20">Set Rate:</span>
                                <div class="card-input flex items-center space-x-3 flex-1">
                                    <input formControlName="rate" class="input-no-spinner bg-gray-100 italic text-xs text-black placeholder-gray-500 focus:outline-none w-full h-30-px rounded-md pl-2 border border-gray-300" type="number" placeholder="Enter Rate" appOnlyNumber [allowDecimal]="true">
                                </div>
                            </div>
                            
                            <!-- USING REUSABLE COMPONENT HERE -->
                            <div class="flex flex-row gap-2 items-center">
                                <span class="text-xs font-semibold w-20">Set Date:</span>
                                <div class="card-input flex items-center space-x-3 flex-1">
                                    <app-date-input 
                                        class="w-full"
                                        [parentForm]="presetForm" 
                                        controlName="date" 
                                        [min]="minDate">
                                    </app-date-input>
                                </div>
                            </div>

                            <div class="flex flex-row gap-2 items-center justify-center mt-2">
                                <button (click)="closePopup()" class="uppercase custom-btn power-btn2 font-semibold px-8 py-2 text-xs">Cancel</button>
                                <button (click)="savePreSet()" class="uppercase power-btn2 active custom-btn font-semibold px-8 py-2 text-xs">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>